import { ExceptionFilter, Catch, ArgumentsHost, HttpException, HttpStatus, Options } from '@nestjs/common';
import { Response } from 'express';
import { PinoLogger } from 'nestjs-pino';
// import * as fs from 'fs';
// import * as path from 'path';

@Catch(HttpException)
export class HttpExceptionFilter implements ExceptionFilter {
    catch(exception: HttpException, host: ArgumentsHost) {
        const ctx = host.switchToHttp();
        const response = ctx.getResponse<Response>();
        const request = ctx.getRequest();
        // const folderPath = path.join(__dirname, 'logs');
        // fs.existsSync(folderPath) || fs.mkdirSync(folderPath);
        // const filePath = folderPath+'/error.log.json';
        // const writableStream = fs.createWriteStream(filePath, {flags: 'a'}); stream: writableStream
        const logger = new PinoLogger({pinoHttp: {level: 'error'}});
        const {body} = request;
        const loggingObject = {
            requestData: body,
            responseData: {}
        };

        let statusCode:number = null ;
        let errorType: string;
        let statusInfo: any;
        let internalMessage: string;
        if(exception instanceof HttpException) {
            const status = exception.getStatus();
            // 4XX series
            if(status >= 400 && status < 500) {
                statusCode = status;
                errorType = 'Client Side Errors';
                internalMessage = exception.message;
            }
            if (status === HttpStatus.BAD_REQUEST) {
                //400
                if (Array.isArray(exception.message)) {
                    const errorMessage = this.getChildMessage(exception.message);
                    statusInfo = errorMessage;
                } else {
                    statusInfo = 'Server cannot or will not process the request due to client error(Request Payload)';
                }
                if (status === HttpStatus.BAD_REQUEST) {
                    //400
                    if (Array.isArray(exception.message)) {
                        const errorMessage = this.getChildMessage(exception.message);
                        statusInfo = errorMessage;
                    } else {
                        statusInfo = 'Server cannot or will not process the request due to client error(Request Payload)';
                    }
                }else if (status === HttpStatus.UNAUTHORIZED) {
                    //401
                    statusInfo = 'Lack of valid authentication credentials';
                }else if (status === HttpStatus.FORBIDDEN) {
                    //403
                    statusInfo = 'Server understood the request but refuses to authorize it';
                }else if (status === HttpStatus.NOT_FOUND) {
                    //404
                    statusInfo = 'Server can\'t find the requested resource';
                }else if (status === HttpStatus.NOT_ACCEPTABLE) {
                    //406
                    statusInfo = 'Response headers not matching with Request headers';
                }else if (status === HttpStatus.EXPECTATION_FAILED) {
                    //417
                    statusInfo = 'Request Header could not fulfilled';
                }else if(status === HttpStatus.TOO_MANY_REQUESTS) {
                    //429
                    statusInfo = 'Too many requests in limited time';
                }
            } else {
                statusCode = 500;
                statusInfo = 'Internal Server Error';
            }

            const responseObject = {
                status: false,
                statusCode: statusCode,
                errorType: errorType,
                internalMessage: statusInfo,
                statusInfo: internalMessage
            }
            loggingObject.responseData = responseObject;
            logger.error(loggingObject);
            response.json(responseObject);
        }
    }

    getChildMessage = (messages : any) => {
        if (messages.children) {
            if (messages.children.length == 0) {
                return Object.values(messages.constraints)[0];
            } else {
                return this.getChildMessage(messages.children[0]);
            }
        }
    }
}
